module.exports = __webpack_public_path__ + "media/images/soar/faq_red-c667c296797ead78aaa4edebaabd411c.png";